var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('remove-btn',{attrs:{"click-fun":_vm.handleShowDeleteDialog}}),_vm._v(" "),_c('DeleteBlockDialog',{on:{"close":function($event){_vm.visible = false},"delete-block":_vm.deleteBlock},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }